import React from 'react'
import SEO from './SEO';

const About = () => {
    return (
        <div>
            <SEO
                title="About us | Insight for Innovation"
                description="Know more about our journey"
                canonicalEnd="about-us"
            />

            <div
                className="general-content wrapper"
                style={{
                    lineHeight: "1.7",
                    fontSize: "16px",
                    color: "#333",
                    padding: "20px",
                    maxWidth: "1100px",
                    margin: "0 auto"
                }}
            >
                <h1
                    style={{
                        fontSize: "2.2rem",
                        fontWeight: "700",
                        marginBottom: "1rem",
                        color: "#1b2a49",
                        textAlign: "left"
                    }}
                >
                    About Us
                </h1>

                <div
                    className="top"
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        gap: "40px",
                        flexWrap: "wrap",
                        marginBottom: "1.5rem"
                    }}
                >
                    <div
                        className="left"
                        style={{
                            flex: "1",
                            minWidth: "320px",
                            textAlign: "justify"
                        }}
                    >
                        Insight for Innovation (Registered under Centre to Promote
                        Self Organised Learning), founded in 2014, strives to reshape
                        education through collaborative efforts between colleges, schools,
                        and corporates. Our organization aims to establish a framework that
                        enables society to unite and deliver quality education for children
                        of Government and Government-aided schools, thereby eliminating gaps
                        in education.
                    </div>

                    <div
                        className="right"
                        style={{
                            flex: "1",
                            minWidth: "320px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <iframe
                            width="100%"
                            height="280"
                            src="https://www.youtube.com/embed/ZRr3SXAG_TA?feature=oembed"
                            title="About Insight for Innovation"
                            frameBorder="0"
                            style={{ borderRadius: "8px", margin: "0" }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>

                {/* Vision Section */}
                <h2
                    style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        marginTop: "1.5rem",
                        marginBottom: "0.5rem",
                        color: "#2a3d66",
                        borderLeft: "4px solid #3f51b5",
                        paddingLeft: "10px"
                    }}
                >
                    Our Vision
                </h2>
                <p style={{ marginBottom: "1rem", textAlign: "justify" }}>
                    To establish a framework that enables society to unite and deliver quality education for children and eliminating gaps in education.
                </p>

                {/* Mission Section */}
                <h2
                    style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        marginTop: "1.5rem",
                        marginBottom: "0.5rem",
                        color: "#2a3d66",
                        borderLeft: "4px solid #3f51b5",
                        paddingLeft: "10px"
                    }}
                >
                    Our Mission
                </h2>
                <p style={{ marginBottom: "1rem", textAlign: "justify" }}>
                    To create a culture where society can take collective responsibility to nurture and transform the younger generation through education.
                </p>

                {/* Work Section */}
                <div className="bottom" style={{ marginTop: "1.5rem" }}>
                    <h2
                        style={{
                            fontSize: "1.5rem",
                            fontWeight: "700",
                            marginBottom: "0.8rem",
                            color: "#2a3d66",
                            borderLeft: "4px solid #3f51b5",
                            paddingLeft: "10px"
                        }}
                    >
                        Our Work
                    </h2>

                    <ul
                        style={{
                            marginLeft: "18px",
                            marginTop: "0.5rem",
                            marginBottom: "1rem",
                            paddingLeft: "10px"
                        }}
                    >
                        <li style={{ marginBottom: "0.6rem" }}>
                            <b>Bridging Academic Gaps:</b> Scalable programs to bridge
                            learning gaps and foster learnability skills in students.
                        </li>
                        <li style={{ marginBottom: "0.6rem" }}>
                            <b>Transformational Impact:</b> In-depth interventions focusing
                            on Social-Emotional Learning, cognitive development, and critical
                            thinking.
                        </li>
                        <li style={{ marginBottom: "0.6rem" }}>
                            <b>Empowering Ecosystem:</b> Supporting parents and teachers
                            with 21st-century digital skills and child-centric learning
                            approaches.
                        </li>
                        <li style={{ marginBottom: "0.6rem" }}>
                            <b>Community Building:</b> Upskilling volunteers with
                            career-essential skills and creating opportunities for growth.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default About;